export const TranformtionTextToShortTextWithEllipsis = {
    "name": "shortText",
    "filter": [() => {
        return (input,text,size) => {
            let result = (!text || text.length <= size) ? text : text.slice(0,size) + '...'
            return result;
        }
    }]
};


// WEBPACK FOOTER //
// ./src/app/common/pipes/shortTextWithEllipsis.js